import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=657df2d6&scoped=true"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657df2d6",
  null
  
)

export default component.exports